import React from 'react';
import {
  JoinMasterclassLink,
  LearnMoreLink,
  PeopleMagicProfitAnnouncementBarContainer,
} from './PeopleMagicProfitAnnouncementBar.styles';
import Heading from 'src/elements/typography/heading';
import { palette } from 'src/styles/colors';
import Paragraph from 'src/elements/typography/paragraph';

const PeopleMagicProfitAnnouncementBar = (): JSX.Element => {
  return (
    <PeopleMagicProfitAnnouncementBarContainer>
      <Heading
        text='Join the FREE Masterclass'
        standardSize='1.25'
        color={palette.white}
        align='center'
        className='coming-soon-heading'
      />
      <Paragraph
        text='People Magic Profit: How to Build a $1M Community '
        standardSize='1.5'
        size='1.25rem' // Override the standard size since this is a temporary announcement
        align='center'
        color={palette.white}
        className='people-magic-profit-announcement-paragraph'
      />
      <LearnMoreLink to='/peoplemagic'>Sign Up Now</LearnMoreLink>
      <JoinMasterclassLink to='/peoplemagic'>
        Join the FREE Masterclass{' '}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='17'
          viewBox='0 0 17 17'
          fill='none'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M11.2362 7.79683C11.6213 8.1864 11.6213 8.81332 11.2362 9.20289L7.21116 13.2745C6.58287 13.91 5.5 13.4651 5.5 12.5714V4.42828C5.5 3.5346 6.58287 3.0897 7.21116 3.72525L11.2362 7.79683Z'
            fill='white'
          />
        </svg>
      </JoinMasterclassLink>
    </PeopleMagicProfitAnnouncementBarContainer>
  );
};

export default PeopleMagicProfitAnnouncementBar;
